import { Injectable } from "@angular/core";
import { HTTPWrapperContext, RequestConfigImplementation, REQUEST_METHODS, XHR_STRATEGIES } from "@ptl/xhr";

@Injectable({
    providedIn: 'root'
})
export class PlanDetailsDocumentsService {

    removeableTerms: string[] = [
        'prestige',
        'signature',
        'distinct',
        'valor',
        'valuerx',
        'select',
        'classic',
        'deluxe',
        'basic',
        'plus',
        'complete',
        'standard',
        'merit',
        'premier'
    ];
    overrideNameResourceMap: any = {};
    documentPageRoot: string = '/resources/medicare-library/plan-documents/';
    expFragRoot: string = '/content/experience-fragments/highmark/en/';
    ignorePrefixRule: boolean = false;

    constructor(private httpClient: HTTPWrapperContext) { }

    initConfig(config) {
        let contentRemoveableTerms = config.get('removeableTerms');
        let contentOverrideNameResourceMap = config.get('overrideNameResourceMap');
        let contentDocumentPagePath = config.get('documentPageRoot');
        let contentExpFragRoot = config.get('expFragRoot');
        let contentIgnorePrefixRule = config.get('ignorePrefixRule');
        
        this.removeableTerms = contentRemoveableTerms ? JSON.parse(contentRemoveableTerms) : this.removeableTerms;
        this.overrideNameResourceMap = contentOverrideNameResourceMap ? JSON.parse(contentOverrideNameResourceMap) : this.overrideNameResourceMap;
        this.documentPageRoot = contentDocumentPagePath ? contentDocumentPagePath : this.documentPageRoot;
        this.expFragRoot = contentExpFragRoot ? contentExpFragRoot : this.expFragRoot;
        this.ignorePrefixRule = contentIgnorePrefixRule === 'true' ? true : false;
    }

    getDocumentPageFromPlanName(rawPlanName: string): Promise<string> {
        let url;

        // Allow for the specific url override for a set of plan names
        if (this.overrideNameResourceMap[rawPlanName.toLowerCase()]) {
            url = this.overrideNameResourceMap[rawPlanName.toLowerCase()];
        }
        else {
            url = this.getDocumentPagePath(this.parsePlanNamePath(rawPlanName));
        }

        return this.makeRequest(url);
    }

    getBasePlanName(planName: string): string {
        if (!planName?.trim()) {
            return '';
        }

        let planPath = planName.toLowerCase().trim();

        this.removeableTerms.forEach((term) => {
            // ignore the first word in case of overlap like we have with 'complete'
            if (planPath.indexOf(term) > 0 || this.ignorePrefixRule) {
                planPath = planPath.replace(term, '');
            }
        });

        // NY has parenthesis in the plan names and we need to strip those out
        planPath = planPath.replace(/(\(|\))/g, '');

        return planPath.trim();
    }

    private makeRequest(url: string): Promise<string> {
        const requestConfig = new RequestConfigImplementation({
            method: REQUEST_METHODS.GET,
            url: url,
            responseType: 'text'
        });

        this.httpClient.setStrategy(XHR_STRATEGIES.DATAPOWER_MIDDLEWARE);
        this.httpClient.disableErrorSnackbar(requestConfig);
        
        return this.httpClient.makeRequest(requestConfig);
    }

    private parsePlanNamePath(planName: string): string {
        // Remove extraneous plan terms like "prestige" to go to the root plan path in the resources section
        let planPath = this.getBasePlanName(planName);
        // Remove any instance of multiple spaces together to not add extra dashes on the next step
        planPath = planPath.replace(/ +/g, ' ');
        // Replace spaces with dashes to complete the full path to the html page
        planPath = planPath.replace(/ /g, '-');

        return planPath;
    }

    private getDocumentPagePath(planPath: string): string {
        return this.documentPageRoot + `${planPath}.html`;
    }
}